
// Register Global VeeValidate components
import {ValidationObserver, ValidationProvider, extend, localize, setInteractionMode} from "vee-validate";
import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';

import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import VTextAreaWithValidation from '@/components/VTextAreaWithValidation.vue';
import Vue from 'vue'

export const setupVeeValidate = () => {

    // import all rules
    for (const [rule, validation] of Object.entries(rules)) {
        extend(rule, {
            ...validation
        });
    }
    setInteractionMode('eager'); // https://logaretm.github.io/vee-validate/guide/interaction-and-ux.html#interaction-modes

    // register it globally
    Vue.component('ValidationProvider', ValidationProvider);
    Vue.component('ValidationObserver', ValidationObserver);

    Vue.component('v-text-field-with-validation', VTextFieldWithValidation);
    Vue.component('v-textarea-with-validation', VTextAreaWithValidation);

    // add all the default rules.
    localize('en', en)
}
